import { memo } from 'react';
import { UserRegister2Template } from 'components/templates/UserRegister2Template';

type Props = {};

export const UserRegister2Page = memo((_props: Props) => {
	return <UserRegister2Template />;
});
